import FuseUtils from "@fuse/utils";
import AppContext from "app/AppContext";
import { Component } from "react";
import { matchRoutes } from "react-router-dom";
import withRouter from "@fuse/core/withRouter";
import history from "@history";
import { isPathAllowed } from "app/configs/moduleAccessConfig";

let loginRedirectUrl = null;

/** Where a restricted user is sent when they open a module they were not granted. */
const FORBIDDEN_URL = "/pages/error/403";

class FuseAuthorization extends Component {
  constructor(props, context) {
    super(props);
    const { routes } = context;
    this.state = {
      accessGranted: true,
      denialReason: null,
      routes,
    };
    this.defaultLoginRedirectUrl = props.loginRedirectUrl || "/";
  }

  componentDidMount() {
    this.checkAccess();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.location.pathname !== this.props.location.pathname ||
      prevProps.userRole !== this.props.userRole ||
      // re-check when the user's module grants change (e.g. after a re-login)
      prevProps.moduleAccess?.key !== this.props.moduleAccess?.key
    ) {
      this.checkAccess();
    }
  }

  static getDerivedStateFromProps(props, state) {
    const { location, userRole, moduleAccess } = props;
    const { pathname } = location;

    const matchedRoutes = matchRoutes(state.routes, pathname);
    const matched = matchedRoutes ? matchedRoutes[0] : null;

    /* 1. role check - stock Fuse behaviour */
    const roleGranted = matched
      ? FuseUtils.hasPermission(matched.route.auth, userRole)
      : true;

    /* 2. module check - only applies to *-restricted users */
    const moduleGranted = roleGranted ? isPathAllowed(pathname, moduleAccess) : true;

    let denialReason = null;
    if (!roleGranted) denialReason = "role";
    else if (!moduleGranted) denialReason = "module";

    return {
      ...state,
      accessGranted: roleGranted && moduleGranted,
      denialReason,
    };
  }

  checkAccess() {
    const { accessGranted } = this.state;

    if (!accessGranted) {
      this.redirectRoute();
    }
  }

  redirectRoute() {
    const { location, userRole } = this.props;
    const { pathname } = location;
    const redirectUrl = loginRedirectUrl || this.defaultLoginRedirectUrl;

    /*
        User is guest
        Redirect to Login Page
        */
    if (!userRole || userRole.length === 0) {
      setTimeout(() => history.push("/sign-in"), 0);
      loginRedirectUrl = pathname;
      return;
    }

    /*
        User is signed in but this module was not granted to them.
        Show the "not allowed" page instead of silently bouncing them
        to their dashboard.
        */
    if (this.state.denialReason === "module") {
      loginRedirectUrl = this.defaultLoginRedirectUrl;
      setTimeout(() => history.push(FORBIDDEN_URL), 0);
      return;
    }

    /*
        User is member
        User must be on unAuthorized page or just logged in
        Redirect to dashboard or loginRedirectUrl
        */
    setTimeout(() => history.push(redirectUrl), 0);
    loginRedirectUrl = this.defaultLoginRedirectUrl;
  }

  render() {
    // console.info('Fuse Authorization rendered', this.state.accessGranted);
    return this.state.accessGranted ? <>{this.props.children}</> : null;
  }
}

FuseAuthorization.contextType = AppContext;

export default withRouter(FuseAuthorization);
